// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Client/Star/Star.css
// module id = 2009
// module chunks = 0